import React from 'react';
import { ChefHat, Utensils, LeafyGreen, Heart, UserRound, Pill, UtensilsCrossed, Activity, Salad, Book, Users, Compass, Target } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

interface ObjectiveItem {
  id: string;
  name: string;
  icon: React.ReactNode;
  bgColor: string;
  textColor: string;
}

interface UserObjectivesProps {
  objectives: string[];
  showTitle?: boolean;
}

const UserObjectives: React.FC<UserObjectivesProps> = ({ objectives, showTitle = true }) => {
  const { user } = useAuth();
  
  const allObjectives: Record<string, ObjectiveItem> = {
    healthy_eating: {
      id: 'healthy_eating',
      name: 'Comer saludable',
      icon: <Utensils size={16} />,
      bgColor: 'bg-green-100',
      textColor: 'text-green-800',
    },
    plant_based: {
      id: 'plant_based',
      name: 'Transición plant based',
      icon: <LeafyGreen size={16} />,
      bgColor: 'bg-emerald-100',
      textColor: 'text-emerald-800',
    },
    weight_loss: {
      id: 'weight_loss',
      name: 'Perder grasa',
      icon: <Heart size={16} />,
      bgColor: 'bg-red-100',
      textColor: 'text-red-800',
    },
    muscle_gain: {
      id: 'muscle_gain',
      name: 'Aumentar masa muscular',
      icon: <UserRound size={16} />,
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-800',
    },
    revert_pathology: {
      id: 'revert_pathology',
      name: 'Revertir patología',
      icon: <Pill size={16} />,
      bgColor: 'bg-purple-100',
      textColor: 'text-purple-800',
    },
    improve_digestion: {
      id: 'improve_digestion',
      name: 'Mejorar digestiones',
      icon: <UtensilsCrossed size={16} />,
      bgColor: 'bg-amber-100',
      textColor: 'text-amber-800',
    },
    body_recomposition: {
      id: 'body_recomposition',
      name: 'Recomposición corporal',
      icon: <Activity size={16} />,
      bgColor: 'bg-indigo-100',
      textColor: 'text-indigo-800',
    },
    varied_food: {
      id: 'varied_food',
      name: 'Comer más variado',
      icon: <Salad size={16} />,
      bgColor: 'bg-lime-100',
      textColor: 'text-lime-800',
    },
    learn_recipes: {
      id: 'learn_recipes',
      name: 'Aprender recetas',
      icon: <Book size={16} />,
      bgColor: 'bg-cyan-100',
      textColor: 'text-cyan-800',
    },
    meet_people: {
      id: 'meet_people',
      name: 'Conocer a nuevas personas',
      icon: <Users size={16} />,
      bgColor: 'bg-pink-100',
      textColor: 'text-pink-800',
    },
  };
  
  const userObjectives = objectives
    .map(id => allObjectives[id])
    .filter(obj => obj !== undefined);
  
  if (userObjectives.length === 0) {
    return null;
  }
  
  return (
    <div className="mt-4">
      {showTitle && (
        <h3 className="font-medium mb-3 flex items-center gap-2">
          <Target className="h-5 w-5 text-blue-500" />
          <span>Objetivos</span>
        </h3>
      )}
      <div className="flex flex-wrap gap-2">
        {userObjectives.map((objective) => (
          <div
            key={objective.id}
            className={`px-3 py-1.5 rounded-full flex items-center gap-1.5 ${objective.bgColor} ${objective.textColor}`}
          >
            {objective.icon}
            <span className="text-sm font-medium">{objective.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserObjectives;
